import { render, staticRenderFns } from "./empty_layout.vue?vue&type=template&id=1261a6a3&scoped=true"
import script from "./empty_layout.vue?vue&type=script&lang=ts"
export * from "./empty_layout.vue?vue&type=script&lang=ts"
import style0 from "./empty_layout.vue?vue&type=style&index=0&id=1261a6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261a6a3",
  null
  
)

export default component.exports